import { Button, Col, Container, Form, Row } from "react-bootstrap";
import PageTitle from "../../../components/PageTitle";
import ReactQuill from "react-quill";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import WebService from "../../../Services/WebService";
import { CmsPageInterface } from "../../../assets/interfaces/RBACInterface";
import CompoLoader from "../../../components/ComponentLoader/CompoLoader";
import PageLoader from "../../../components/Common/PageLoader/PageLoader";
const EditCms = () => {
    let navigate = useNavigate();
    let id = useParams().id;
    const [loading, setLoading] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [cms, setCmsPage] = useState<CmsPageInterface>(
        { title: '', content: '', code: '', locale: 'en', created_at: '', updated_at: '', status: '', url: '' }
    );
    useEffect(() => {
        if (id) {
            getDetails();
        }
    }, [id]);
    const getDetails = () => {
        setLoading(true);
        WebService.getAPI({
            action: 'cms-pages/' + id,
            body: null,
        }).then((res: any) => {
            setLoading(false);
            setCmsPage(res.data);
        }).catch((err: any) => {
            setLoading(false);
        });
    }

    const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setErrorFlag(false);
        let flag = false;
        if (cms.title.trim() === '' || cms.content.trim() === undefined) {
            flag = true;
            setErrorFlag(true);
        }
        if (cms.content.trim() === '<p><br></p>' || cms.content.trim() === undefined || cms.content.trim() === null) {
            flag = true;
            setErrorFlag(true);
        }
        if (flag) {
            return;
        }
        WebService.putAPI({
            action: 'cms-pages/' + id,
            body: cms,
            btnId: 'save-cms'
        }).then((res: any) => {
            navigate('/restaurant-admin/settings/manage-cms');
        }).catch((err: any) => {

        });
    }
    return (
        <>
            <Container fluid className="page-container">
                <Row className='align-items-center justify-content-between mb-3'>
                    <Col xl={12} xxl={12} className='mb-lg-0 mb-3 d-flex align-items-center'>
                        <PageTitle title={"Edit CMS"} backArrow={true} />
                    </Col>
                </Row>
                {loading ? <PageLoader /> :
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="table-card p-4 p-lg-5">
                                <form >
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <Form.Group className="mb-0">
                                                <Form.Label className="fw-medium">Page Name </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    id="name"
                                                    value={cms.title}
                                                    onChange={(e) => setCmsPage({ ...cms, title: e.target.value })}
                                                    key={"name"}
                                                    placeholder="Enter page name"
                                                />
                                                {errorFlag && cms.title.trim() === '' && <span className="text-danger font-12">This field is required</span>}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <div className="mb-4">
                                                <ReactQuill
                                                    theme="snow"
                                                    defaultValue={cms.content}
                                                    onChange={(value) => setCmsPage({ ...cms, content: value })}
                                                    style={{ height: "200px" }}
                                                />
                                            </div>
                                        </Col>
                                        {errorFlag && cms.content.trim() === '<p><br></p>' && <span className="font-12 mt-4 text-danger">This field is required</span>}
                                    </Row>
                                    <div className="text-center mt-4">
                                        <Button variant="primary mt-4 px-5" id="save-cms" onClick={(e: any) => { handleSave(e) }} type="submit">
                                            SAVE
                                        </Button>
                                    </div>
                                </form>

                            </div>
                        </Col>
                    </Row>
                }
            </Container>
        </>
    )

}

export default EditCms;